// test1521
(1521 && 0);
